<template>
<div class="alarm-pane">
    <b-modal :active.sync="timedModalActive" has-modal-card>
        <time-range-modal v-bind:alarm="modal" v-on:save="saveTimedDialog"
                          onClose="toggleTimedDialog()"></time-range-modal>
    </b-modal>

    <section v-if="errorMessage" style="margin-bottom: 20px;">
        <div class="text-centered" style="border: solid 1px red; color: #FF2E12; padding: 10px;">
            {{$t('alarm.errorMessage2')}}
            <br/>
            <br/>
            {{$t('alarm.errorMessage1')}}
        </div>
    </section>

    <section>
        <div class="b-tabs">
            <div class="tabs is-toggle-rounded is-centered is-toggle">
                <ul class="timer">
                    <li v-bind:class="{'is-active': !alarmContinuous.enabled && !alarmLimited.enabled }" @click="saveAlarms(0)"><a>{{ $t('alarm.off') | uppercase }}</a></li>
                    <li class="btn-middle" v-bind:class="{'is-active': alarmContinuous.enabled }" @click="saveAlarms(1)"><a>{{ $t('alarm.on') | uppercase }}</a></li>
                    <li v-bind:class="{'is-active': alarmLimited.enabled }" @click="saveAlarms(2)"><a>{{ $t('alarm.timed') | uppercase }}</a></li>
                </ul>
            </div>
        </div>
    </section>

    <section>
        <div class="text-centered" v-if="!alarmContinuous.enabled && !alarmLimited.enabled">{{ $t('alarm.alarm_inactive') }}</div>
        <div class="text-centered" v-if="alarmContinuous.enabled"><b>{{ $t('alarm.alarm_active') }}</b></div>
        <div class="text-centered" v-if="alarmLimited.enabled">{{ $t('alarm.alarm_active_from') }}
            <b>{{moveFrom | moment('HH:mm')}}</b> {{ $t('alarm.to') }}
            <b>{{moveTo | moment('HH:mm')}}</b>
            (<a @click="toggleTimedDialog">{{ $t('alarm.edit') }}</a>)
        </div>
    </section>

    <section>
        <hr style="background: white; margin: 20px 0;">
        <div style="font-size: 18px;">
            <input type="checkbox" id="push" name="push" v-model="alarm.alarmPUSH" @change="saveAlarms(null,'push')"/>
            <label for="push" style="margin-left: 10px;">{{ $t('alarm.push') }}</label>
        </div>
        <div style="font-size: 18px;">
            <input type="checkbox" id="sms" name="sms" v-model="alarm.alarmSMS" :disabled="alarm.phoneNumber.length < 1" @change="saveAlarms(null,'sms')"/>
            <label for="sms" style="margin-left: 10px;">SMS</label>
        </div>
    </section>

    <section style="margin-left: 30px;">
        <table class="table contact-table">
            <tbody>
            <tr v-for="(number, n) in alarm.phoneNumber" :key="n">
                <td>{{number}}</td>
                <td><i class="fas fa-trash fa-sm is-clickable" @click="removeNumber(n)"></i></td>
            </tr>
            </tbody>
            <tfoot>
            <tr v-if="alarm.phoneNumber.length < 1">
                <td colspan="3">{{ $t('alarm.add_recipient') }}</td>
            </tr>
            <tr v-if="alarm.phoneNumber.length < 3">
                <td>
                    <p class="control has-icons-left">
                        <input class="input" type="tel" placeholder="+386 ..." v-model="newNumber">
                        <span class="icon is-small is-left">
                            <i class="fas fa-phone"></i>
                        </span>
                    </p>
                </td>
                <td v-if="newNumber">
                    <i class="fas fa-plus is-clickable" @click="addNumber()"></i>
                </td>
            </tr>
            </tfoot>
        </table>
    </section>

    <b-modal has-modal-card>
        <TimeRangeModal></TimeRangeModal>
    </b-modal>
</div>
</template>

<script>
import TimeRangeModal from '../modals/TimeRangeModal';
import Vue2Filters from 'vue2-filters';

function addZero(i) {
    if (i < 10) i = '0' + i;
    return i;
}
export default {
    name: 'Info',
    components: { TimeRangeModal },
    mixins: [Vue2Filters.mixin],
    data() {
        return {
            alarm: {
                deviceID: 0,
                alarm: 0,
                phoneNumber: [],
                from: new Date(),
                to: new Date(),
                alarmSMS: false,
                alarmPUSH: false
            },
            modal: {
                from: new Date(),
                to: new Date()
            },
            saving: false,
            timedModalActive: false,
            newNumber: '',
            errorMessage: this.$t('')
        };
    },
    methods: {
        toggleTimedDialog() {
            this.modal.from = this.moveFrom;
            this.modal.to = this.moveTo;
            this.timedModalActive = !this.timedModalActive;
            this.saving = this.timedModalActive;
        },
        saveTimedDialog() {
            this.alarm.alarm.alarm.find(item => item.type === 'limited').timeLimits.from = addZero(this.modal.from.getHours()) + ':' + addZero(this.modal.from.getMinutes());
            this.alarm.alarm.alarm.find(item => item.type === 'limited').timeLimits.to = addZero(this.modal.to.getHours()) + ':' + addZero(this.modal.to.getMinutes());
            this.saveAlarms(-1);
            this.toggleTimedDialog();
        },
        addNumber() {
            this.alarm.phoneNumber.push(this.newNumber);
            this.alarm.alarm.notification.find(item => item.type === 'sms').phoneNumbers = this.alarm.phoneNumber.join(',');
            this.saveAlarms(-1);
            this.newNumber = '';
        },
        removeNumber(idx) {
            if (confirm(this.$t('alarm.confirm_remove_number') + this.alarm.phoneNumber[idx] + '?')) {
                this.alarm.phoneNumber.splice(idx, 1);
                this.alarm.alarm.notification.find(item => item.type === 'sms').phoneNumbers = this.alarm.phoneNumber.join(',');
                this.saveAlarms(-1);
            }
        },
        makeAlarm() {
            let alarm = {};
            alarm.deviceID = this.device.id;
            alarm.alarm = this.moveAlarm;
            alarm.phoneNumber = this.moveNumbers;
            alarm.from = this.moveFrom;
            alarm.to = this.moveTo;
            alarm.alarmSMS = this.moveAlarmSMS;
            alarm.alarmPUSH = this.moveAlarmPUSH;
            return alarm;
        },
        saveAlarms(mode, notification) { // if mode < 0 then keep previous setting
            if (mode === 0) {
                this.alarm.alarm.alarm.find(item => item.type === 'continuous').enabled = false;
            } else if (mode === 1) {
                this.alarm.alarm.alarm.find(item => item.type === 'continuous').enabled = true;
            } else if (mode === 2) {
                this.alarm.alarm.alarm.find(item => item.type === 'limited').enabled = !this.alarm.alarm.alarm.find(item => item.type === 'limited').enabled;
            }
            if (notification === 'sms') {
                this.alarm.alarm.notification.find(item => item.type === 'sms').enabled = !this.alarm.alarm.notification.find(item => item.type === 'sms').enabled;
            } else if (notification === 'push') {
                this.alarm.alarm.notification.find(item => item.type === 'push').enabled = !this.alarm.alarm.notification.find(item => item.type === 'push').enabled;
            }

            this.saving = true;
            let alarm = {};
            alarm.deviceID = this.device.id;
            alarm.alarm = this.alarm.alarm;

            if (alarm.alarm.alarm.find(item => item.type === 'limited').timeLimits.from === null) {
                alarm.alarm.alarm.find(item => item.type === 'limited').timeLimits.from = '';
            }

            if (alarm.alarm.alarm.find(item => item.type === 'limited').timeLimits.to === null) {
                alarm.alarm.alarm.find(item => item.type === 'limited').timeLimits.to = '';
            }

            this.$store.dispatch('data/UPDATE_ALARM', alarm).finally(() => {
                this.saving = false;
                this.errorMessage = false;
            }).catch((response) => {
                this.errorMessage = true;
            });
        }
    },
    computed: {
        alarmSMS: function() {
            if (this.$store.getters.selectedDevice.moveAlarmSettings) {
                return this.$store.getters.selectedDevice.moveAlarmSettings.notification.find(item => item.type === 'sms').enabled;
            }
            return null;
        },
        alarmPUSH: function() {
            if (this.$store.getters.selectedDevice.moveAlarmSettings) {
                return this.$store.getters.selectedDevice.moveAlarmSettings.notification.find(item => item.type === 'push').enabled;
            }
            return null;
        },
        alarmLimited: function() {
            if (this.$store.getters.selectedDevice.moveAlarmSettings) {
                return this.$store.getters.selectedDevice.moveAlarmSettings.alarm.find(item => item.type === 'limited');
            }
            return null;
        },
        alarmContinuous: function() {
            if (this.$store.getters.selectedDevice.moveAlarmSettings) {
                return this.$store.getters.selectedDevice.moveAlarmSettings.alarm.find(item => item.type === 'continuous');
            }
            return null;
        },
        device: function() {
            return this.$store.getters.selectedDevice;
        },
        moveNumbers: function() {
            if (this.$store.getters.selectedDevice.moveAlarmSettings) {
                const notificationSMS = this.$store.getters.selectedDevice.moveAlarmSettings.notification.find(item => item.type === 'sms');
                if (notificationSMS && notificationSMS.phoneNumbers && notificationSMS.phoneNumbers !== '') {
                    let nums = notificationSMS.phoneNumbers.split(',');
                    if (nums[0].length > 0) return nums;
                }
            }
            return [];
        },
        moveAlarm: function() {
            if (this.$store.getters.selectedDevice.moveAlarmSettings) {
                return this.$store.getters.selectedDevice.moveAlarmSettings;
            }
            return 0;
        },
        moveFrom: function() {
            if (this.$store.getters.selectedDevice.moveAlarmSettings) {
                const alarmLimited = this.$store.getters.selectedDevice.moveAlarmSettings.alarm.find(item => item.type === 'limited');
                if (alarmLimited && alarmLimited.timeLimits.from !== null && alarmLimited.timeLimits.from !== '') {
                    let hours = alarmLimited.timeLimits.from.split(':');
                    let d = new Date();
                    d.setHours(hours[0], hours[1]);
                    return d;
                }
            }
            return new Date();
        },
        moveTo: function() {
            if (this.$store.getters.selectedDevice.moveAlarmSettings) {
                const alarmLimited = this.$store.getters.selectedDevice.moveAlarmSettings.alarm.find(item => item.type === 'limited');
                if (alarmLimited && alarmLimited.timeLimits.to !== null && alarmLimited.timeLimits.to !== '') {
                    let hours = alarmLimited.timeLimits.to.split(':');
                    let d = new Date();
                    d.setHours(hours[0], hours[1]);
                    return d;
                }
            }
            return new Date();
        },
        moveAlarmSMS: function() {
            if (this.$store.getters.selectedDevice.moveAlarmSettings) {
                return this.$store.getters.selectedDevice.moveAlarmSettings.notification.find(item => item.type === 'sms').enabled;
            }
            return false;
        },
        moveAlarmPUSH: function() {
            if (this.$store.getters.selectedDevice.moveAlarmSettings) {
                return this.$store.getters.selectedDevice.moveAlarmSettings.notification.find(item => item.type === 'push').enabled;
            }
            return false;
        }
    },
    watch: {
        'device': function() {
            if (!this.saving) {
                this.alarm = this.makeAlarm();
            }
        }
    }
};
</script>

<style lang="scss">
    .text-centered {
        text-align: center;
    }

    .is-clickable {
        cursor: pointer;
    }

    .alarm-pane > section {
        margin: 0.5em 0;
    }

    .timepicker {
        display: inline-block;
        margin: 0 0.5em;
    }

    .timepicker-wrapper {
        text-align: center;
    }

    .timepicker .dropdown-content .control .select select {
        font-size: 0.9em;
    }

    .timepicker-dash {
        position: relative;
        top: 0.5em;
    }

    .contact-table {
        width: 100%;
        background-color: $panel-table;

        tbody td:last-child {
            text-align: right;
        }
    }

    .b-tabs {
        margin-bottom: 0;
    }

    .modal-card-body {
        background-color: $panel-black;
    }

    .tabs-bar  {
        .timer .btn-middle a {
            padding-left: 1.4rem;
            padding-right: 1.4rem;
        }
    }
</style>
